import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { c1, MENU_BUTTON_CODE, MENU_BUTTON_STYLE } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-audio-picker",
  templateUrl: "./button-audio-picker.component.html",
  styleUrls: ["./button-audio-picker.component.scss"],
})
export class ButtonAudioPickerComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    public builderService: BuilderService
  ) { }

  @Input() button: MenuButton;
  @Input() fontSmaller = false;
  @Input() mode: string;
  @Input() fontResize ;

  @Input() row_id: string;

  @Input() data: Tab;
  @Input() colors: any;
  @Input() no_buttons = 1;
  //////////////////// what have been used //////////////
  currentMenuSubscription: any;
  updateBuilderComponentSubscription: any;
  colorsComponentSubscription: any;
  offCanvasSubscription: any;
  bgImageP1: string =null;
  card_round: string;
  sec_round: string;
  transparent : boolean = false
  bg_image: string = null
  bg_color: string = null // = "#000000";;
  start_color: string = null// = "#1be6e2";
  end_color: string = null//= "#1be6e2";
  image: string = null;
  album_button: any;
  albums: any;
  emptyImage: string;
  emptyImageP0: string;
  emptyImageP1: string;
  emptyImageP2: string;
  widthP0: string;
  styleP0: number = 1;
  styleP1: number =0;
  styleP2: number =0;
  label: string;
  sublable: string;
  label_color: string;
  sublabel_color: string;
  settings: any;

  border_color: string;
  imageOvel: string;
  /////
  isAndroid: boolean;
  current_button: any;
  isActive: boolean;
  light: boolean = true;
  color_schema: any;
  color_schema_ios: any;
  label_align: string;
  sublabel_align: string;
  label_size: string;
  sublabel_size: string;

  textAlign: any = {};
  textFontsize: any = {};
  outlined: boolean;
  elevated: boolean;
  filled: boolean;
  shadow: boolean;
  surfaceColor : string;
  placeholderIcon: string;
  placeHolderBG:string;
  placeholderIconColor:string;
  fontSizeIcon;
  trailing_icon_color: string;
  trailing_bg_color: string;
  trailing_icon: string;
  ngOnInit() {
    let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
    this.initialize(this.button.button_style, this.no_buttons)

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe((data) => {
      if (data && !data.fromButton) {
        if (data["sortedButtonList"][this.row_id]) {
          this.no_buttons = data["sortedButtonList"][this.row_id].length > 0 ? data["sortedButtonList"][this.row_id].length : 1
          this.current_button = data["currentButton"];
          this.isActive = this.current_button && (this.current_button.button_id == this.button.button_id) ? true : false

          let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;

          this.initialize(style, this.no_buttons)
        }
      }
    })



    this.colorsComponentSubscription = this.mdw.colorsComponentContainer$.subscribe(
      (data) => {
        if (data  && data.color_schema  && data.color_schema_ios && data.light !=null) {
          this.colors = data;
          this.light = data.light
          let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
          this.initialize(style, this.no_buttons)
        }
      })
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        // only for getting default button to change style for active or none active button style

        if (data && data.button) {

          this.current_button = data.button;
          this.isActive = this.current_button && (this.current_button.button_id == this.button.button_id) ? true : false
          let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
          this.initialize(style, this.no_buttons)
        }
      }
    );


    this.updateBuilderComponentSubscription =
      this.mdw.updateBuilderComponentContainer$.subscribe((data) => {
        if (data && data.tab) {
          // only to get different views for button for Android and iOS. if both same view we do not need this subscription.
        this.isAndroid = localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;
        let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
         this.initialize(style, this.no_buttons)
        }
      });

  }

  initialize(style, no_button) {
    this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;

    if (this.colors &&  this.colors.color_schema && this.button) {
      this.color_schema = this.light ? this.colors.color_schema.schemes.light : this.colors.color_schema.schemes.dark;
      this.color_schema_ios = this.light ? this.colors.color_schema_ios.schemes.light : this.colors.color_schema_ios.schemes.dark

      let drop_style = this.convertStyle(style);
      this.album_button = album_button_map[drop_style];
      this.albums = this.album_button.albums
      this.emptyImage = this.album_button.emptyFullImage[no_button];
      this.settings = this.album_button.settings;
      this.card_round =  this.album_button.card_round;
      this.sec_round = this.album_button.sec_round;

      this.emptyImageP0 = this.albums[0].emptyImage[no_button];
      this.emptyImageP1 = this.albums[1].emptyImage[no_button];
      this.widthP0 = this.albums[0].width[no_button];


      this.textAlign = this.isAndroid?this.button.button_text_align:this.button.button_text_align_ios
      this.textFontsize =this.isAndroid?this.button.button_text_fontsize:this.button.button_text_fontsize_ios
      this.label_size = this.textFontsize && this.textFontsize.headline? this.textFontsize.headline : null;
      this.sublabel_size = this.textFontsize && this.textFontsize.subhead ? this.textFontsize.subhead: null;

      this.border_color = this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'outline', 'outline', this.light);
      this.placeholderIcon = this.button.button_icon_placeholder ? this.button.button_icon_placeholder : "mis_headphones";

      //*** This is background should be set instead of unset as unset takes directly from browser colors*/
      this.surfaceColor = this.isAndroid ? this.builderService.buttonColor(null, this.colors.color_schema, null, 'surface', this.light):this.builderService.buttonColor(null, this.colors.color_schema_ios, null, 'surface', this.light)


      this.themeColors(drop_style);
      this.cardStyle(style);

    }


  }

  themeColors(style) {
    switch (style) {
      case MENU_BUTTON_STYLE?.STYLE_06:
          // this.image = this.button.button_img_url? this.button.button_img_url : null;
        this.image = this.isAndroid?
        this.light? this.button.button_img_url?this.button.button_img_url: null : this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url?this.button.button_img_url:null :
        this.light? this.button.button_img_url_ios?this.button.button_img_url_ios: null : this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios?this.button.button_img_url_ios:null

        this.bg_image = null;
        this.bg_color=null;
        // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
        // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        // this.sublabel_color = this.button.button_subhead_color;

        this.start_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'primaryContainer', this.light)
        :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'primaryContainer', this.light)

        this.end_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'primaryContainer', this.light)
        : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'primaryContainer', this.light)

        // this.bg_color = this.isAndroid ?
        //   this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'primaryContainer', this.light)
        //   : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'primaryContainer', this.light)

        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onPrimaryContainer', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onPrimaryContainer', this.light)

        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onPrimaryContainer', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onPrimaryContainer', this.light)

          this.label_align = 'center'
          this.sublabel_align = 'center'
        break;
      case MENU_BUTTON_STYLE?.STYLE_03:
        // this.image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios
        this.image = this.isAndroid?
        this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
        this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios


        this.bg_image = null;
        this.bg_color=null;
        // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
        // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
        this.styleP0 = 2;

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        // this.sublabel_color = this.button.button_subhead_color;


        this.start_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
        :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

        this.end_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
        : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

        // this.bg_color = this.isAndroid ?
        //   this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainer', this.light)
        //   : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainer', this.light)

        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)


          this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
          this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;
        break;
      case MENU_BUTTON_STYLE?.STYLE_05:

      // check this....
        // move it to the bgimage  Hazem /// TDL

        this.bg_image = this.isAndroid ? this.light? this.button.button_bgimage: this.button.button_bgimage_dark? this.button.button_bgimage_dark: this.button.button_bgimage :
        this.light? this.button.button_bgimage_ios: this.button.button_bgimage_dark_ios? this.button.button_bgimage_dark_ios: this.button.button_bgimage_ios
        this.start_color = null
        this.end_color = null
        this.bg_color = null;
        this.styleP1 = 0

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;

        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

       // this.bg


        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)


    this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
    this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;

      break;
      case MENU_BUTTON_STYLE?.STYLE_04:
        this.image = null
        this.bg_image = null;
        this.bg_color = null;

        // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
        // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
        this.styleP1 = 0

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        // this.sublabel_color = this.button.button_subhead_color;


        this.start_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'primaryContainer', this.light)
        :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'primaryContainer', this.light)

        this.end_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'primary', this.light)
        : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'primary', this.light);


        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurfaceVariant', this.light)

        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurface', this.light)

          this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
          this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;

       break;
      case MENU_BUTTON_STYLE?.STYLE_07:
      //  this.image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios
       this.image = this.isAndroid?
        this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
        this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios


       this.bg_image = null;
       this.bg_color = null;
        // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
        // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
        this.styleP0 = 3;

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        // this.sublabel_color = this.button.button_subhead_color;
        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'primary', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'primary', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'primary', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'primary', this.light)



        // this.bg_color = this.isAndroid ?
        //   this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'primary', this.light)
        //   : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'primary', this.light)

        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurfaceVariant', this.light)

        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurface', this.light)



        break;
      case MENU_BUTTON_STYLE?.STYLE_08:
        // this.image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios;
        this.image = this.isAndroid?
        this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
        this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios


        this.bg_image = null;
        // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
        // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
        this.styleP0 = 3;

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        // this.sublabel_color = this.button.button_subhead_color;

        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'secondary', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'secondary', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'secondary', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'secondary', this.light)


        // this.bg_color = this.isAndroid ?
        //   this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'secondary', this.light)
        //   : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'secondary', this.light)

        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurfaceVariant', this.light)

        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurface', this.light)
        break;
      case MENU_BUTTON_STYLE?.STYLE_09:
          // this.image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios
          this.image = this.isAndroid?
          this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
          this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios

          this.bg_image = null;
          this.bg_color=null;
          // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
          // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
          this.styleP0 = 2;

          this.label = this.button.button_headline;
          this.sublable = this.button.button_subhead;
          // this.sublabel_color = this.button.button_subhead_color;


          this.start_color = this.isAndroid ?
           this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
          :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

          this.end_color = this.isAndroid ?
           this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

          // this.bg_color = this.isAndroid ?
          //   this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainer', this.light)
          //   : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainer', this.light)

          this.label_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

          this.sublabel_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)


            this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
            this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;
          break;
      case MENU_BUTTON_STYLE?.STYLE_10:
        // this.bg_image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios

        this.bg_image = this.isAndroid?
        this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
        this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios


        this.image= null
        this.start_color = null
        this.end_color = null
        this.bg_color = null;
        this.styleP1 = 0
        this.styleP0 =0,
        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;

        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)
       // this.bg
        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)
        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)

    this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
    this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;

      break;
      case MENU_BUTTON_STYLE?.STYLE_11:
        this.emptyImageP2 = this.albums[2].emptyImage[this.no_buttons];
        this.image = null;
        this.bg_image=null;
        this.bgImageP1 = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios
        this.start_color = null
        this.end_color = null
        this.bg_color = null;
        this.styleP0 = 0;
        this.styleP1 =4;
        this.styleP2 = 0;

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;

        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

       // this.bg

        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)


    this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
    this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;


      break;
      case MENU_BUTTON_STYLE?.STYLE_12:
        this.bg_image=null;
        this.image = this.isAndroid?
        this.light? this.button.button_img_url?this.button.button_img_url: null : this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url?this.button.button_img_url:null :
        this.light? this.button.button_img_url_ios?this.button.button_img_url_ios: null : this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios?this.button.button_img_url_ios:null
        this.start_color = null
        this.end_color = null
        this.bg_color = null;
        this.styleP0 = 0;
        this.styleP1 =5;
        this.imageOvel = this.albums[1].imageOvel;
        this.styleP2 = 0;
        this.widthP0 = this.fontSmaller?this.albums[1].widthfontSmaller[this.no_buttons]:this.fontResize?this.albums[1].widthFontResize[this.no_buttons]:this.albums[1].width[this.no_buttons];
        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

       this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

       this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)

       this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
       this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;

          break;
      case MENU_BUTTON_STYLE?.STYLE_01:
           // this.image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios

        this.image = this.button.button_value && this.button.button_value.length > 0 ? this.button.button_value[0].value.url : null;
        this.trailing_icon = this.isAndroid ? this.button.button_trailing_icon : this.button.button_trailing_icon_ios;
        this.placeHolderBG= this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, "noChange", "outlineVariant", this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios,this.colors.color_schema_ios,"noChange","outlineVariant",this.light);
        this.placeholderIconColor= this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, "noChange", "surfaceContainerLowest", this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios,this.colors.color_schema_ios,"noChange","surfaceContainerLowest",this.light);
        this.fontSizeIcon = [32,16, 8];
        this.bg_image = null;
        this.bg_color=null;
        this.styleP0 = 2;
        this.label = this.button.button_headline;
        this.start_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
        :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)
        this.end_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
        : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)
        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

        this.trailing_bg_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'trailing_bg', 'primary', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'trailing_bg', 'primary', this.light);
        this.trailing_icon_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'trailing_icon', 'onPrimary', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'trailing_icon', 'onPrimary', this.light);

          this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
          this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;
          break;
      case MENU_BUTTON_STYLE?.STYLE_14:
        this.image = this.isAndroid?
        this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
        this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios
        this.bg_image = null;
        this.bg_color=null;
        this.styleP0 = 2;

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        this.start_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
        :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

        this.end_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
        : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)

          this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
          this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;

          break;
      case MENU_BUTTON_STYLE?.STYLE_15:
        this.bg_image=null;

        this.image = this.isAndroid?
        this.light? this.button.button_img_url?this.button.button_img_url: null : this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url?this.button.button_img_url:null :
        this.light? this.button.button_img_url_ios?this.button.button_img_url_ios: null : this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios?this.button.button_img_url_ios:null
        this.start_color = null
        this.end_color = null
        this.bg_color = null;
        this.styleP0 = 0;
        this.styleP1 =6;
        this.imageOvel = this.albums[1].imageOvel;
        this.styleP2 = 0;
        this.widthP0 = this.fontSmaller?this.albums[1].widthfontSmaller[this.no_buttons]:this.fontResize?this.albums[1].widthFontResize[this.no_buttons]:this.albums[1].width[this.no_buttons];
        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

       this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

       this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)

       this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
       this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;

          break;
      case MENU_BUTTON_STYLE?.STYLE_16:
          this.bg_image=null;

        this.image = this.isAndroid?
        this.light? this.button.button_img_url?this.button.button_img_url: null : this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url?this.button.button_img_url:null :
        this.light? this.button.button_img_url_ios?this.button.button_img_url_ios: null : this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios?this.button.button_img_url_ios:null
        this.start_color = null
        this.end_color = null
        this.bg_color = null;
        this.styleP0 = 0;
        this.styleP1 =6;
        this.imageOvel = this.albums[1].imageOvel;
        this.styleP2 = 0;
        this.widthP0 = this.fontSmaller?this.albums[1].widthfontSmaller[this.no_buttons]:this.fontResize?this.albums[1].widthFontResize[this.no_buttons]:this.albums[1].width[this.no_buttons];
        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

       this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

       this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)

       this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
       this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;

          break;
      case MENU_BUTTON_STYLE?.STYLE_17:
          // this.image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios
          this.image = this.isAndroid?
          this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
          this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios

          this.bg_image = null;
          this.bg_color=null;
          // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
          // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
          this.styleP0 = 2;

          this.label = this.button.button_headline;
          this.sublable = this.button.button_subhead;
          // this.sublabel_color = this.button.button_subhead_color;


          this.start_color = this.isAndroid ?
           this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
          :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

          this.end_color = this.isAndroid ?
           this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

          // this.bg_color = this.isAndroid ?
          //   this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainer', this.light)
          //   : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainer', this.light)

          this.label_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

          this.sublabel_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)


            this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
            this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;
          break;
      case MENU_BUTTON_STYLE?.STYLE_18:
          // this.image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios
          this.image = this.isAndroid?
          this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
          this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios

          this.bg_image = null;
          this.bg_color=null;
          // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
          // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
          this.styleP0 = 2;

          this.label = this.button.button_headline;
          this.sublable = this.button.button_subhead;
          // this.sublabel_color = this.button.button_subhead_color;


          this.start_color = this.isAndroid ?
           this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
          :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

          this.end_color = this.isAndroid ?
           this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

          // this.bg_color = this.isAndroid ?
          //   this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainer', this.light)
          //   : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainer', this.light)

          this.label_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

          this.sublabel_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)


            this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
            this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;
          break;
      case MENU_BUTTON_STYLE?.STYLE_19:
          // this.image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios
          this.image = this.isAndroid?
          this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
          this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios

          this.bg_image = null;
          this.bg_color=null;
          // this.start_color = this.button.button_bgstart? this.button.button_bgstart: this.button.button_bgcolor;
          // this.end_color = this.button.button_bgend? this.button.button_bgend: this.button.button_bgcolor;
          this.styleP0 = 2;

          this.label = this.button.button_headline;
          this.sublable = this.button.button_subhead;
          // this.sublabel_color = this.button.button_subhead_color;


          this.start_color = this.isAndroid ?
           this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
          :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

          this.end_color = this.isAndroid ?
           this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

          // this.bg_color = this.isAndroid ?
          //   this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainer', this.light)
          //   : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainer', this.light)

          this.label_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

          this.sublabel_color = this.isAndroid ?
            this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
            : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)


            this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
            this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;
      break;
      case MENU_BUTTON_STYLE?.STYLE_20:
          this.bg_image=null;
         this.emptyImageP2 = this.albums[2].emptyImage[this.no_buttons];
        this.image = this.isAndroid?
        this.light? this.button.button_img_url?this.button.button_img_url: null : this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url?this.button.button_img_url:null :
        this.light? this.button.button_img_url_ios?this.button.button_img_url_ios: null : this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios?this.button.button_img_url_ios:null
        this.start_color = null
        this.end_color = null
        this.bg_color = null;
        this.styleP0 = 0;
        this.styleP1 =5;
        this.imageOvel = this.albums[1].imageOvel;
        this.styleP2 = 0;
        this.widthP0 = this.fontSmaller?this.albums[1].widthfontSmaller[this.no_buttons]:this.fontResize?this.albums[1].widthFontResize[this.no_buttons]:this.albums[1].width[this.no_buttons];
        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)

       this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)

       this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)

       this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
       this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;

          break;
   case MENU_BUTTON_STYLE?.STYLE_21:
        // this.bg_image = this.isAndroid ? this.button.button_img_url : this.button.button_img_url_ios
        this.bg_image = this.isAndroid?
        this.light? this.button.button_img_url: this.button.button_img_url_dark? this.button.button_img_url_dark: this.button.button_img_url:
        this.light? this.button.button_img_url_ios: this.button.button_img_url_dark_ios? this.button.button_img_url_dark_ios: this.button.button_img_url_ios
        this.image= null
        this.start_color = null
        this.end_color = null
        this.bg_color = null;
        this.styleP1 = 0
        this.styleP0 =0,
        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;

        this.start_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgstart', 'surfaceContainer', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgstart', 'surfaceContainer', this.light)

       this.end_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bgend', 'surfaceContainer', this.light)
       : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bgend', 'surfaceContainer', this.light)
       // this.bg
        this.label_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'headline', 'onSurface', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'headline', 'onSurface', this.light)
        this.sublabel_color = this.isAndroid ?
          this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'subhead', 'onSurfaceVariant', this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'subhead', 'onSurfaceVariant', this.light)

    this.label_align = this.textAlign && this.textAlign.headline? this.textAlign.headline : null;
    this.sublabel_align = this.textAlign && this.textAlign.subhead ? this.textAlign.subhead: null;
      break;

        }

  }
  get setButtonBg() {

    if (this.bg_image) {
      this.transparent = false;
      return {
        "background-image": `url(${this.bg_image})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover",
      };
    } else if (this.start_color && this.end_color) {
      this.transparent = false;
      return {
        "background-image": `linear-gradient(180deg, ${this.start_color}, ${this.end_color})`,
      };
    } else if (this.bg_color) {
      this.transparent = false;
      return { background: this.bg_color };
    } else {
      this.transparent = true;
      // return { background: "unset" };
       return { background: this.surfaceColor };
    }
  }


  //fontSmalller for sideMobile
  // forntResize for Mobile View

  get lableColor() {
    return {
      "color": this.label_color,
      // 'font-size': this.fontSmaller ? '5px' : (this.settings && this.settings.titleSize) ? this.settings.titleSize : '12px',
      'font-size': this.fontSmaller ? '5px' : this.fontResize? this.fontScale('headline', '12px'): this.fontScale('headline', '16px'),
    };
  }

  get sublableColor() {
    return {
      "color": this.sublabel_color,
      // 'font-size': this.fontSmaller ? '3px' : '9px',
      'font-size': this.fontSmaller ? '3px' : this.fontResize? this.fontScale('subhead', '10px'): this.fontScale('subhead', '14px'),

    };
  }


  get setImageP1() {
      if (this.bgImageP1) {
      return {
        "background-image": `url(${this.bgImageP1})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover",
      };
    } else if (this.start_color && this.end_color) {
      return {
        "background-image": `linear-gradient(180deg, ${this.start_color}, ${this.end_color})`,
      };
    } else if (this.bg_color) {
      return { background: this.bg_color };
    } else {
      // return { background: "unset" };
      return { background: this.surfaceColor };

    }
  }

  get bgPlaceHolderColor() {
    return {
      'background-color': this.placeHolderBG,
    };
  }

  get traillingBgColor() {
    return {
      background: this.trailing_bg_color,
      'height': this.fontSmaller ? '8px' : this.fontResize ? '20px' : '30px',
      'width': this.fontSmaller ? '8px' : this.fontResize ? '20px' : '30px',
      top: '5%',
      right: '2%',
    };
  }

  get traillingIconColor() {
    return {
      color: this.trailing_icon_color,
      "font-size": this.fontSmaller ? "4px" : this.fontResize ? "12px" : "16px",
    };
  }




  fontScale(item, value) {
    let result: number;

    result = value.replace("px", "");

    // large is greater +2 and smaller is less -2
    if (this.textFontsize && this.textFontsize[item]) {

      switch (this.textFontsize[item]) {
        case 'sm':
          result = Number(result) - 2;
          return result + 'px'
          break;
        case 'xs':
          result = Number(result) - 4;
          return result + 'px'
          break;
        case 'xxs':
          result = Number(result) - 6;
          return result + 'px'
          break;
        case 'md':
          return Number(result) + 'px'
          break;
        case 'lg':
          result = Number(result) + 2;
          return result + 'px'
          break;
        case 'xl':
          result = Number(result) + 4;
          return result + 'px'
          break;
        case 'xxl':
          result = Number(result) + 6;
          return result + 'px'
          break;
      }
    } else {
      return value
    }
  }

  convertStyle (style){

    //x000 : old style
    //x   : old style
    //2nd : N/A   0: (some cells is divider)
    //3rd : card type
            // 0:elevated (shadow, no outline, bg),
            // 1: filled (no shadow, no outline and bg),
            // 2: outlined (no shadow, outline, bg)  //used to be boarder 1/0
            // 3: Custom
            // 4: transparent

    let cell_style = style.slice(0,2);

    return cell_style;

}
cardStyle (style){

  //x000 : old style
  //x   : old style
  //2nd : N/A   0: (some cells is divider)
  //3rd : card type
          // 0:elevated (shadow, no outline, bg),
          // 1: filled (no shadow, no outline and bg),
          // 2: outlined (no shadow, outline, bg)  //used to be boarder 1/0
          // 3: Custom
          // 4: transparent

  switch (Number(style[3])){
    case  0:
      // elevated card
      this.outlined = false;
      this.shadow  = true;
      this.start_color = null;
      this.end_color = null;
      this.bg_color = this.isAndroid ?
      this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainerLow', this.light)
     :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainerLow', this.light) ;
      break;
    case 1:
      // filled card
    this.outlined = false;
    this.shadow  = false
    this.start_color = null;
    this.end_color = null;
     this.bg_color = this.isAndroid ?
     this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainerHighest', this.light)
    :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainerHighest', this.light)
    break;

   case 2:
      // outlined card
      this.outlined = true;
      this.shadow  = false
      this.start_color = null;
      this.end_color = null;
       this.bg_color = this.isAndroid ?
       this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surface', this.light)
      :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surface', this.light)

    break;

    case 4:
      this.outlined = false;
      this.shadow  = false;
      this.start_color = null;
      this.end_color = null;
      this.bg_color = null;
      break;

    default:

      break;
  }

}
  ngOnDestroy(): void {
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }

    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }

    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
  }

}


export const album_button_map = {
  // id = no. of button per row //
  [MENU_BUTTON_STYLE?.STYLE_06]: {
    albums: [
      {
        id: 0,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash10.webp",
          2: "./assets/images/mobile-2/splash10.webp",
          3: "./assets/images/mobile-3/splash10.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        width: { 1: "15%", 2: "30%", 3: "45%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash10.webp",
          2: "./assets/images/mobile-2/splash10.webp",
          3: "./assets/images/mobile-3/splash10.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash20.webp",
      2: "./assets/images/mobile-2/splash20.webp",
      3: "./assets/images/mobile-3/splash20.webp",
    },
    card_round: null,
    sec_round: null,
  },
  [MENU_BUTTON_STYLE?.STYLE_03]: {
    albums: [
      {
        id: 0,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash10.webp",
          2: "./assets/images/mobile-2/splash10.webp",
          3: "./assets/images/mobile-3/splash10.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-top-3",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash10.webp",
          2: "./assets/images/mobile-2/splash10.webp",
          3: "./assets/images/mobile-3/splash10.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash20.webp",
      2: "./assets/images/mobile-2/splash20.webp",
      3: "./assets/images/mobile-3/splash20.webp",
    }, //100

    card_round:"rounded-3",
    sec_round: "rounded-3",
  },
  [MENU_BUTTON_STYLE?.STYLE_05]: {
    albums: [
      {
        id: 0,
        en: false,
        emptyImage: {},
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash20.webp",
          2: "./assets/images/mobile-2/splash20.webp",
          3: "./assets/images/mobile-3/splash20.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",

      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash20.webp",
      2: "./assets/images/mobile-2/splash20.webp",
      3: "./assets/images/mobile-3/splash20.webp",
    }, //100

    card_round: "rounded-3",
    sec_round: "rounded-3",


  },
  [MENU_BUTTON_STYLE?.STYLE_04]: {
    albums: [
      {
        id: 0,
        en: false,
        emptyImage: {},
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash20.webp",
          2: "./assets/images/mobile-2/splash20.webp",
          3: "./assets/images/mobile-3/splash20.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash20.webp",
      2: "./assets/images/mobile-2/splash20.webp",
      3: "./assets/images/mobile-3/splash20.webp",
    }, //100

    card_round: null,
    sec_round: null,

  },
  [MENU_BUTTON_STYLE?.STYLE_13]: {
    albums: [
      {
        id: 0,
        en: false,
        emptyImage: {},
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash10.webp",
          2: "./assets/images/mobile-2/splash10.webp",
          3: "./assets/images/mobile-3/splash10.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash10.webp",
      2: "./assets/images/mobile-2/splash10.webp",
      3: "./assets/images/mobile-3/splash10.webp",
    }, //100
    settings: { titleSize: "14px" },
    card_round: "rounded-2",
    sec_round: null,
  },
  [MENU_BUTTON_STYLE?.STYLE_07]: {
    albums: [
      {
        id: 0,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash20.webp",
          2: "./assets/images/mobile-2/splash20.webp",
          3: "./assets/images/mobile-3/splash20.webp",
        },
        padding: "10px",
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        width: { 1: "100%", 2: "100%", 3: "100%" },

      },
      {
        id: 1,
        en: false,
        emptyImage: {},
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash20.webp",
      2: "./assets/images/mobile-2/splash20.webp",
      3: "./assets/images/mobile-3/splash20.webp",
    }, //100
    card_round: null,
    sec_round: null,

  },
  [MENU_BUTTON_STYLE?.STYLE_08]: {
    albums: [
      {
        id: 0,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash18.webp",
          2: "./assets/images/mobile-2/splash18.webp",
          3: "./assets/images/mobile-3/splash18.webp",
        },
        padding: "10px",
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        width: { 1: "90%", 2: "90%", 3: "90%" },
      },
      {
        id: 1,
        en: false,
        emptyImage: {},
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash18.webp",
      2: "./assets/images/mobile-2/splash18.webp",
      3: "./assets/images/mobile-3/splash18.webp",
    }, //100
    card_round: null,
    sec_round: null,
  },
  [MENU_BUTTON_STYLE?.STYLE_09]: {
    albums: [
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash22.png",
          2: "./assets/images/mobile-2/splash22.png",
          3: "./assets/images/mobile-3/splash22.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-2",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash5.png",
          2: "./assets/images/mobile-2/splash5.png",
          3: "./assets/images/mobile-3/splash5.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash27.png",
      2: "./assets/images/mobile-2/splash27.png",
      3: "./assets/images/mobile-3/splash27.png",
    }, //100
  },
  [MENU_BUTTON_STYLE?.STYLE_10]: {
    albums: [
      {
        id: 0,
        en: false,
        emptyImage: {
          },
        padding: '10px',
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        width: { 1: "80%", 2: "80%", 3: "80%" },
      },
      {
        id: 1,
        en: false,
        emptyImage: {
          1: "./assets/images/mobile/splash22.png",
          2: "./assets/images/mobile-2/splash22.png",
          3: "./assets/images/mobile-3/splash22.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: false,
        emptyImage: {},
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash22.png",
      2: "./assets/images/mobile-2/splash22.png",
      3: "./assets/images/mobile-3/splash22.png",
    }, //100
  },

  [MENU_BUTTON_STYLE?.STYLE_11]: {
    albums: [
      {
        id: 0,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash2.png",
          2: "./assets/images/mobile-2/splash2.png",
          3: "./assets/images/mobile-3/splash2.png",

        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash16.png",
          2: "./assets/images/mobile-2/splash16.png",
          3: "./assets/images/mobile-3/splash16.png",
        },
        padding: '10px',
        opacity: 0,
        blur: "0px",
        round: "rounded-2",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash5.png",
          2: "./assets/images/mobile-2/splash5.png",
          3: "./assets/images/mobile-3/splash5.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash23.png",
      2: "./assets/images/mobile-2/splash23.png",
      3: "./assets/images/mobile-3/splash23.png",
    }, //100
  },
  [MENU_BUTTON_STYLE?.STYLE_12]:  {
    albums: [
          {
        id: 0,
        en: false,
        emptyImage: {
          1: "",
          2: "",
          3: "",
          4: "",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        image_round: "",
        imageOvel:"",
        width: { 1: "80%", 2: "60%", 3: "40%" },
         },
        {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash12.png",
          2: "./assets/images/mobile-2/splash12.png",
          3: "./assets/images/mobile-3/splash12.png",
          4: "./assets/images/mobile-4/splash12.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-2",
        width: { 1: "80%", 2: "80%", 3: "80%", 4: "80%" },
        widthfontSmaller: { 1: "50%", 2: "100%", 3: "100%", 4:"100%"  },
        widthFontResize: { 1: "50%", 2: "100%", 3:"100%", 4: "100%" },
        image_round: "rounded-0",
        imageOvel:"./assets/images/small/emptyoval12.png",

      },
      {
        id: 2,
        en: false,
        emptyImage: {
          1: "",
          2: "",
          3: "",
          4: "",

        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash12.png",
      2: "./assets/images/mobile-2/splash12.png",
      3: "./assets/images/mobile-3/splash12.png",
      4: "./assets/images/mobile-4/splash12.png",
    }, //100
  },
   [MENU_BUTTON_STYLE?.STYLE_01]: {
    albums: [
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash18.webp",
          2: "./assets/images/mobile-2/splash18.webp",
          3: "./assets/images/mobile-3/splash18.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        image_round: "rounded-3",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash5.png",
          2: "./assets/images/mobile-2/splash5.png",
          3: "./assets/images/mobile-3/splash5.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        image_round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash23.png",
      2: "./assets/images/mobile-2/splash23.png",
      3: "./assets/images/mobile-3/splash23.png",
    }, //100
  },
   [MENU_BUTTON_STYLE?.STYLE_14]:{
    albums: [
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash18.webp",
          2: "./assets/images/mobile-2/splash18.webp",
          3: "./assets/images/mobile-3/splash18.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        image_round: "rounded-3",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash5.png",
          2: "./assets/images/mobile-2/splash5.png",
          3: "./assets/images/mobile-3/splash5.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        image_round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash23.png",
      2: "./assets/images/mobile-2/splash23.png",
      3: "./assets/images/mobile-3/splash23.png",
    }, //100
  },
   [MENU_BUTTON_STYLE?.STYLE_15]:  {
    albums: [
          {
        id: 0,
        en: false,
        emptyImage: {
          1: "",
          2: "",
          3: "",
          4: "",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        image_round: "rounded-0",
        width: { 1: "80%", 2: "60%", 3: "40%" },
       imageOvel:""
        },
        {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash16.png",
          2: "./assets/images/mobile-2/splash16.png",
          3: "./assets/images/mobile-3/splash16.png",
          4: "./assets/images/mobile-4/splash16.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-2",
        image_round: "rounded-0",
        width: { 1: "80%", 2: "80%", 3: "80%", 4: "80%" },
        widthfontSmaller: { 1: "50%", 2: "100%", 3: "100%", 4:"100%"  },
        widthFontResize: { 1: "50%", 2: "100%", 3:"100%", 4: "100%" },
        imageOvel:"./assets/images/small/emptyoval16.png"
      },
      {
        id: 2,
        en: false,
        emptyImage: {
          1: "",
          2: "",
          3: "",
          4: "",

        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        image_round: "rounded-0",
        imageOvel:""

      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash16.png",
      2: "./assets/images/mobile-2/splash16.png",
      3: "./assets/images/mobile-3/splash16.png",
      4: "./assets/images/mobile-4/splash16.png",
    }, //100
  },
  [MENU_BUTTON_STYLE?.STYLE_16]: {
    albums: [
          {
        id: 0,
        en: false,
        emptyImage: {
          1: "",
          2: "",
          3: "",
          4: "",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        image_round: "rounded-0",
        width: { 1: "80%", 2: "60%", 3: "40%" },
       imageOvel:""
        },
        {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash7.png",
          2: "./assets/images/mobile-2/splash7.png",
          3: "./assets/images/mobile-3/splash7.png",
          4: "./assets/images/mobile-4/splash7.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-2",
        image_round: "rounded-0",
        width: { 1: "80%", 2: "80%", 3: "80%", 4: "80%" },
        widthfontSmaller: { 1: "50%", 2: "100%", 3: "100%", 4:"100%"  },
        widthFontResize: { 1: "50%", 2: "100%", 3:"100%", 4: "100%" },
        imageOvel:"./assets/images/small/emptyoval7.png"
      },
      {
        id: 2,
        en: false,
        emptyImage: {
          1: "",
          2: "",
          3: "",
          4: "",

        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        image_round: "rounded-0",
        imageOvel:""

      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash7.png",
      2: "./assets/images/mobile-2/splash7.png",
      3: "./assets/images/mobile-3/splash7.png",
      4: "./assets/images/mobile-4/splash7.png",
    }, //100
  },

   [MENU_BUTTON_STYLE?.STYLE_17]: {
    albums: [
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash16.png",
          2: "./assets/images/mobile-2/splash16.png",
          3: "./assets/images/mobile-3/splash16.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        image_round: "rounded-3",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: false,
        emptyImage: {
          1: "",
          2: "",
          3: "",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        image_round: "rounded-0",

      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash16.png",
      2: "./assets/images/mobile-2/splash16.png",
      3: "./assets/images/mobile-3/splash16.png",
    }, //100
  },
   [MENU_BUTTON_STYLE?.STYLE_18]: {
    albums: [
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash22.png",
          2: "./assets/images/mobile-2/splash22.png",
          3: "./assets/images/mobile-3/splash22.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-2",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash5.png",
          2: "./assets/images/mobile-2/splash5.png",
          3: "./assets/images/mobile-3/splash5.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash27.png",
      2: "./assets/images/mobile-2/splash27.png",
      3: "./assets/images/mobile-3/splash27.png",
    }, //100
  },
   [MENU_BUTTON_STYLE?.STYLE_19]: {
    albums: [
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash22.png",
          2: "./assets/images/mobile-2/splash22.png",
          3: "./assets/images/mobile-3/splash22.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-2",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash5.png",
          2: "./assets/images/mobile-2/splash5.png",
          3: "./assets/images/mobile-3/splash5.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash27.png",
      2: "./assets/images/mobile-2/splash27.png",
      3: "./assets/images/mobile-3/splash27.png",
    }, //100
  },
   [MENU_BUTTON_STYLE?.STYLE_20]: {
    albums: [
          {
        id: 0,
        en: false,
        emptyImage: {
          1: "",
          2: "",
          3: "",
          4: "",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        image_round: "",
        imageOvel:"",
        width: { 1: "80%", 2: "60%", 3: "40%" },
         },
        {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash17.png",
          2: "./assets/images/mobile-2/splash17.png",
          3: "./assets/images/mobile-3/splash17.png",
          4: "./assets/images/mobile-3/splash17.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-2",
        width: { 1: "80%", 2: "100%", 3: "100%", 4: "100%" },
        widthfontSmaller: { 1: "50%", 2: "100%", 3: "100%", 4:"100%"  },
        widthFontResize: { 1: "50%", 2: "100%", 3:"100%", 4: "100%" },
        image_round: "rounded-0",
        imageOvel:"./assets/images/small/emptyoval17.png",

      },
      {
        id: 2,
        en: false,
        emptyImage: {
         1: "./assets/images/mobile/splash7.png",
          2: "./assets/images/mobile-2/splash7.png",
          3: "./assets/images/mobile-3/splash7.png",
          4: "./assets/images/mobile-3/splash7.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash20.webp",
      2: "./assets/images/mobile-2/splash20.webp",
      3: "./assets/images/mobile-3/splash20.webp",
      4: "./assets/images/mobile-3/splash20.webp",

    }, //100
  },
  [MENU_BUTTON_STYLE?.STYLE_21]: {
    albums: [
      {
        id: 0,
        en: false,
        emptyImage: {
          },
        padding: '10px',
        opacity: 0,
        blur: "0px",
        round: "rounded-3",
        width: { 1: "80%", 2: "80%", 3: "80%" },
      },
      {
        id: 1,
        en: false,
        emptyImage: {
          1: "./assets/images/mobile/splash60.png",
          2: "./assets/images/mobile-2/splash60.png",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
        width: { 1: "100%", 2: "100%", 3: "100%" },
      },
      {
        id: 2,
        en: false,
        emptyImage: {},
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-0",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash60.png",
      2: "./assets/images/mobile-2/splash60.png",
    }, //100
  },

};
